export default __webpack_public_path__ + "926dfce31a7f332b309682346c264d57.png";